import { createAction, props } from '@ngrx/store';

export interface IGoogleAddressSearchResponse {
  [key: string]: unknown;
}

export const loadGoogleAddressSearchSuccess = createAction(
  '[GoogleAddressSearch] Load Google Address Search Success',
  props<{ response: IGoogleAddressSearchResponse }>()
);
